import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import logoVivia from "../images/logo.png";
import { useTranslation } from "react-i18next";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import PlaceIcon from "@mui/icons-material/Place";
import CallIcon from "@mui/icons-material/Tty";
import { Keys } from "../utils/keys";

import { LinkedIn, MarkAsUnread } from "@mui/icons-material";
function Footer({
  scrollToHomePage,
  scrollToAboutUs,
  scrollToFeatures,
  scrollToProjects,
  scrollToBlog,
  scrollToContact,
}: any) {
  const { t } = useTranslation();
  const theme = useTheme();
  const isNotMobile = useMediaQuery(theme.breakpoints.up("md"));
  const list = [
    t("Homepage"),
    t("About Us"),
    t("Our features"),
    t("Our projects"),
    t("Blog"),
    t("Contact"),
  ];
  const navigateToSection = (item: any) => {
    if (["Homepage", "Accueil"].includes(item)) {
      scrollToHomePage();
    }
    if (["About Us", "À propos de nous"].includes(item)) {
      scrollToAboutUs();
    }
    if (["Our features", "Nos fonctionnalités"].includes(item)) {
      scrollToFeatures();
    }
    if (["Our projects", "Nos projets"].includes(item)) {
      scrollToProjects();
    }
    if (item === "Blog") {
      scrollToBlog();
    }
    if (item === "Contact") {
      scrollToContact();
    }
  };
  const keys = Keys();
  return (
    <Grid>
      <Grid
        container
        sx={{
          justifyContent: "center",
          alignItems: "center",
          gap: 8,

          background:
            "radial-gradient(39.87% 39.87% at 50% 50%, #0C3247 0%, #081525 100%)",
          pt: 6,
          pb: 5,
        }}
      >
        <Grid display="flex" flexDirection="column" rowGap={4}>
          <img
            src={logoVivia}
            alt="logo"
            onClick={scrollToHomePage}
            style={{
              cursor: "pointer",
              width: "60%",
              marginBottom: 3,
            }}
          />
          <Typography
            sx={{
              fontFamily: "Open Sans",
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "22px",
              letterSpacing: "0%",
              textAlign: "justify",
              verticalAlign: "middle",
              color: "#FFF",
              width: 250,
            }}
          >
            {t("With Artificial Intelligence, we bring software to life.")}
          </Typography>
          <Grid display="flex" flexDirection="column" gap={4}>
            <Grid display="flex" alignItems="center" gap={1} height="15px">
              <PlaceIcon sx={{ color: "#47728B" }} />
              <Typography
                sx={{
                  fontFamily: "Roboto",
                  fontWeight: 400,
                  fontSize: "11px",
                  lineHeight: "60px",
                  letterSpacing: "0%",
                  textAlign: "center",
                  verticalAlign: "middle",
                  color: "#FFF",
                }}
              >
                {t("Soft-tech Incubator of the Sousse Technopole")}
              </Typography>
            </Grid>
            <Grid display="flex" alignItems="center" gap={1} height="15px">
              <CallIcon sx={{ color: "#47728B" }} />
              <Typography
                sx={{
                  fontFamily: "Roboto",
                  fontWeight: 400,
                  fontSize: "11px",
                  lineHeight: "60px",
                  letterSpacing: "0%",

                  textAlign: "center",
                  verticalAlign: "middle",
                  color: "#FFF",
                }}
              >
                00324 88 478 494 - 00216 52 830 711
              </Typography>
            </Grid>
            <Grid display="flex" alignItems="center" gap={1} height="15px">
              <MarkAsUnread sx={{ color: "#47728B" }} />
              <Typography
                sx={{
                  fontFamily: "Roboto",
                  fontWeight: 400,
                  fontSize: "11px",
                  lineHeight: "60px",
                  letterSpacing: "0%",
                  textAlign: "center",
                  verticalAlign: "middle",
                  color: "#FFF",
                }}
              >
                contact@viviamobility.com
              </Typography>
            </Grid>
            <Grid display="flex" alignItems="center" gap={1} height="15px">
              <LinkedIn sx={{ color: "#47728B" }} />
              <Typography
                sx={{
                  fontFamily: "Roboto",
                  fontWeight: 400,
                  fontSize: "11px",
                  lineHeight: "60px",
                  letterSpacing: "0%",
                  textAlign: "center",
                  verticalAlign: "middle",
                  color: "#FFF",
                }}
              >
                @VIVIA-M
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        {isNotMobile && (
          <>
            <Grid display="flex" flexDirection="column" gap={2}>
              <Typography
                sx={{
                  fontFamily: "Montserrat",
                  fontWeight: 800,
                  fontSize: "18px",
                  lineHeight: "22px",
                  letterSpacing: "0%",

                  verticalAlign: "middle",
                  color: "#FFF",
                  borderBottom: "2px solid  #FFFFFF33 ",
                  width: "30%",
                  marginBottom: 2,
                }}
              >
                {t("Services")}
              </Typography>
              {keys.map((key, index) => (
                <Grid display="flex" key={index}>
                  <KeyboardDoubleArrowRightIcon
                    sx={{ color: "#FFF" }}
                    fontSize="small"
                  />
                  <Typography
                    sx={{
                      fontFamily: "Open Sans",
                      fontWeight: 400,
                      fontSize: "14px",
                      lineHeight: "22px",
                      letterSpacing: "0%",

                      verticalAlign: "middle",
                      color: "#FFF",
                    }}
                  >
                    {key.title}
                  </Typography>
                </Grid>
              ))}
            </Grid>

            <Grid display="flex" flexDirection="column" gap={2}>
              <Typography
                sx={{
                  fontFamily: "Montserrat",
                  fontWeight: 800,
                  fontSize: "18px",
                  lineHeight: "22px",
                  letterSpacing: "0%",

                  verticalAlign: "middle",
                  color: "#FFF",
                  borderBottom: "2px solid  #FFFFFF33 ",
                  width: "50%",
                  marginBottom: 2,
                }}
              >
                {t("VIVIAMobility")}
              </Typography>
              {list.map((item, index) => (
                <Grid display="flex" key={index}>
                  <KeyboardDoubleArrowRightIcon
                    sx={{ color: "#FFF" }}
                    fontSize="small"
                  />
                  <Typography
                    sx={{
                      fontFamily: "Open Sans",
                      fontWeight: 400,
                      fontSize: "14px",
                      lineHeight: "22px",
                      letterSpacing: "0%",
                      cursor: "pointer",
                      verticalAlign: "middle",
                      color: "#FFF",
                    }}
                    onClick={() => navigateToSection(item)}
                  >
                    {item}
                  </Typography>
                </Grid>
              ))}
            </Grid>
          </>
        )}
        {/* <Grid display="flex" flexDirection="column" gap={5}>
          <Typography
            sx={{
              fontFamily: "Montserrat",
              fontWeight: 800,
              fontSize: "18px",
              lineHeight: "22px",
              letterSpacing: "0%",
              // verticalAlign: "middle",
              color: "#FFF",
              borderBottom: "2px solid  #FFFFFF33 ",
            }}
          >
            {t("Let’s innovate together")}
          </Typography>

          <TextField
            size="small"
            type="text"
            name="name"
            placeholder="Name"
            id="outlined-basic"
            sx={{
              "& .MuiOutlinedInput-root": {
                background: "#FFF",
                // border: " 1px solid #E2E2E2",
              },
            }}
            // value={reclamationInfo?.description}
            // onChange={(event) => {
            //   handleChange(event);
            //   setCharCount(event.target.value.length);
            // }}
          />
          <TextField
            size="small"
            type="text"
            name="email"
            placeholder="E-mail adress"
            id="outlined-basic"
            sx={{
              "& .MuiOutlinedInput-root": {
                background: "#FFF",
                // border: " 1px solid #E2E2E2",
              },
            }}
            // value={reclamationInfo?.description}
            // onChange={(event) => {
            //   handleChange(event);
            //   setCharCount(event.target.value.length);
            // }}
          />

          <Button
            sx={{
              color: "#FFF",
              border: "1px solid #28D1B4",
              bgcolor: " #33BBA4",
              width: "50%",
              // pl: 4,
              // pr: 4,
            }}
          >
            Envoyer
          </Button>
        </Grid> */}
      </Grid>
      <Box sx={{ background: "#33BBA4", p: 3 }}>
        <Typography
          sx={{
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "13px",
            lineHeight: "20.43px",
            letterSpacing: "0%",
            verticalAlign: "middle",
            color: "#FFF",
          }}
        >
          © 2025 VIVIA Mobility
        </Typography>
      </Box>
    </Grid>
  );
}
export default Footer;
